import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { Text } from 'react-native';
import { color } from '@/constant/color';
export default function Question({ children, required = false, multiple = false, }) {
    return (_jsxs(Text, { className: "font-pretendard-medium text-[16px] leading-[28px]", children: [required && _jsx(Text, { style: { color: color.red }, children: "* " }), children, multiple && _jsx(Text, { className: "text-gray-40", children: " (\uC911\uBCF5\uC120\uD0DD)" })] }));
}
